<template>
  <div class="section">
    <div class="container">
      <h1 class="title">Fire Map Dashboard</h1>
      <p class="subtitle">
        Visualize fire hotspots detected across Thailand during the past 5 days
        using satellite-based monitoring.
        <br />
        <strong>Legend:</strong>
        🟡 Yellow = Nominal, 🔴 Red = High
      </p>

      <div class="field">
        <div class="control">
          <ProvinceSelect v-model="selectedProvince" />
        </div>
      </div>

      <FireMap :province="selectedProvince" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import ProvinceSelect from "../components/ProvinceSelect.vue";
import FireMap from "../components/FireMap.vue";
const selectedProvince = ref("phitsanulok");
</script>
